import React from 'react'

const SaveOnFreight = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={40}
                height={40}
                x={0}
                y={0}
                viewBox="0 0 512 512"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className=""
            >
                <g>
                    <path
                        d="m229.93 120.84-47.94 35.85a25.028 25.028 0 0 1-34.4-3.24l93.62-91.66a75.566 75.566 0 0 1 45.18-14.64l78.6 5.74a28.066 28.066 0 0 0 19.97-6.39l13.89-11.28 13.3 76.05-.63.11A74.232 74.232 0 0 1 337 132.05l-4.91-1.4a53.006 53.006 0 0 0-23.66-1.23l-43.95 7.68a33.169 33.169 0 0 1-34.55-16.26ZM282.07 391.16l47.94-35.85a25.028 25.028 0 0 1 34.4 3.24l-93.62 91.66a75.566 75.566 0 0 1-45.18 14.64l-78.6-5.74a28.066 28.066 0 0 0-19.97 6.39l-13.89 11.28-13.3-76.05.63-.11A74.232 74.232 0 0 1 175 379.95l4.91 1.4a53.006 53.006 0 0 0 23.66 1.23l43.95-7.68a33.169 33.169 0 0 1 34.55 16.26Z"
                        style={{}}
                        fill="#f7caa5"
                        data-original="#f7caa5"
                    />
                    <circle
                        cx={256}
                        cy={256}
                        r="84.19"
                        style={{}}
                        fill="#00efd1"
                        data-original="#00efd1"
                        className=""
                    />
                    <path
                        d="M284.93 228h-9.47a22.122 22.122 0 0 0-3.661-8h13.131a8 8 0 0 0 0-16h-57.86a8 8 0 0 0 0 16h16.56c6.381 0 11.942 3 14.792 8H227.07a8 8 0 0 0 0 16h31.359a10.064 10.064 0 0 1-2.907 3.984A16.8 16.8 0 0 1 243.63 253h-16.56a8.147 8.147 0 0 0-5.494 14.017l41.38 39.134a7.989 7.989 0 1 0 10.988-11.6L247.005 269.1a32.858 32.858 0 0 0 19.832-9.666A31.951 31.951 0 0 0 275.474 244h9.456a8 8 0 1 0 0-16Z"
                        style={{}}
                        fill="#fedb41"
                        data-original="#fedb41"
                        className=""
                    />
                    <path
                        d="M213.66 422.492a8 8 0 0 1-1.368-15.882l63.083-11.029q-.126-.233-.256-.461a25.237 25.237 0 0 0-26.219-12.34l-43.95 7.68a61.355 61.355 0 0 1-27.228-1.416l-4.912-1.4a65.968 65.968 0 0 0-66.485 18.441 8 8 0 1 1-11.683-10.93 81.91 81.91 0 0 1 82.55-22.9l4.915 1.4a45.236 45.236 0 0 0 20.083 1.045l43.953-7.68a41.138 41.138 0 0 1 47.646 33.456 8 8 0 0 1-6.5 9.264l-72.24 12.631a8.1 8.1 0 0 1-1.389.121ZM258.794 145.594a41.129 41.129 0 0 1-40.583-34.07 8 8 0 0 1 6.5-9.264l72.24-12.631a8 8 0 1 1 2.756 15.761l-63.083 11.029q.126.233.256.461a25.234 25.234 0 0 0 26.22 12.34l43.95-7.68a61.342 61.342 0 0 1 27.228 1.416l4.912 1.4a65.966 65.966 0 0 0 66.485-18.441 8 8 0 1 1 11.683 10.93 81.912 81.912 0 0 1-82.55 22.9l-4.915-1.4a45.262 45.262 0 0 0-20.083-1.045l-43.953 7.68a40.942 40.942 0 0 1-7.063.614Z"
                        style={{}}
                        fill="#edb288"
                        data-original="#edb288"
                    />
                    <path
                        d="m398.85 35.22-1.54-8.79L445.5 18 464 123.76l-48.19 8.43-3.66-20.92-13.3-76.05zM113.15 476.78l1.54 8.79L66.5 494 48 388.24l48.19-8.43 3.66 20.92 13.3 76.05z"
                        style={{}}
                        fill="#00acea"
                        data-original="#00acea"
                    />
                </g>
            </svg>

        </>
    )
}

export default SaveOnFreight